import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { Column } from '@simplywallst/ui-core';

export const MobileFooterMenuWrapper = styled(Row)`
  position: fixed;
  left: 0;
  bottom: 0;
  height: ${({ theme }) =>
    `calc(${theme.x7spacePx}px + ${theme.safeAreaInsetBottom})`};
  transition: height 0.2s cubic-bezier(0.17, 0.46, 0.64, 0.91);
  width: 100vw;
  background: ${({ theme }) => theme.color.noir};
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  z-index: 9999;
  ${media.lgUp`
		display: none;
	`};
`;

interface MobileFooterMenuItemProps {
  selected: boolean;
}

export const MobileFooterMenuItemDeprecated = styled(
  Column
)<MobileFooterMenuItemProps>`
  ${({ theme }) => theme.typography.tiny};
  color: white;
  text-align: center;
  p {
    margin: 0;
    line-height: normal;
  }
  svg {
    display: inline-block;
    width: ${({ theme }) => theme.x3spacePx}px;
    height: ${({ theme }) => theme.x3spacePx}px;
    * {
      fill: ${({ theme, selected }) =>
        selected ? theme.color.brand01 : theme.color.mediumGray};
    }
  }
  > span,
  > a {
    display: block;
    width: 100%;
    height: 100%;
    padding-top: ${({ theme }) => theme.x1spacePx - 3}px;
    line-height: 1.3;
    user-select: none;
    > span {
      display: block;
      opacity: 0.5;
    }
  }
  &:active {
    background: ${({ theme }) => theme.color.blackRGBA(0.2)};
  }
`;

export const MobileFooterMenuItem = styled(Column)<MobileFooterMenuItemProps>`
  ${({ theme }) => theme.typography.tiny};
  text-align: center;
  /* TODO: Remove p tag from nav items */
  p {
    margin: 0;
    line-height: normal;
  }
  svg {
    display: inline-block;
    width: ${({ theme }) => theme.x3spacePx}px;
    height: ${({ theme }) => theme.x3spacePx}px;
    pointer-events: none;

    * {
      fill: ${({ theme, selected }) =>
        selected ? theme.color.brand01 : theme.color.mediumGray};
    }
  }
  > span,
  > a {
    display: block;
    width: 100%;
    height: 100%;
    padding-top: ${({ theme }) => theme.x1spacePx - 3}px;
    line-height: 1.3;
    user-select: none;
    > span {
      display: block;
    }
  }

  > a {
    transition-duration: 0s;
    color: ${({ theme, selected }) =>
      selected ? theme.color.textSolid : theme.color.mediumGray};

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.color.textSolid};
    }

    &:focus-visible,
    &:active {
      background: ${({ theme }) => theme.color.blackRGBA(0.2)};
    }

    &:hover,
    &:focus,
    &:active {
      svg * {
        fill: ${({ theme, selected }) =>
          selected ? theme.color.brand01 : theme.color.textSolid};
      }
    }
  }

  /* Avoid blue tap color on Chrome on Android */
  -webkit-tap-highlight-color: transparent;
`;
